import React from 'react';
import Dropdown from '../../../../components/Dropdown';
import { truncateText } from '../../../../utility/helper';
import { IoMdAddCircle } from 'react-icons/io';

const Home = ({ healthDropdownOptions, handleOptionSelect, handleAddGroupClick, handleIconClick, handleAddLegacyClick, handleViewWealthClick }) => {

  return (
    <>
      <div className='absolute top-24 left-4'>
        <Dropdown
          options={healthDropdownOptions}
          name={'My View'}
          assetId={""}
          onOptionSelect={handleOptionSelect}
          icon={''}
          truncateText={truncateText}
          size={19}
          direction={'left'}
          className='inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium text-primary bg-secondary rounded-md hover:bg-gray-100 focus:outline-none'
        />
        <button onClick={handleAddGroupClick} className="ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium text-primary bg-secondary rounded-md hover:bg-gray-100 focus:outline-none">
          View Group
        </button>
        <button onClick={handleAddLegacyClick} className="ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium text-primary bg-secondary rounded-md hover:bg-gray-100 focus:outline-none">
          View Legacy
        </button>
        <button
          onClick={handleViewWealthClick}
          className="ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium text-primary bg-secondary rounded-md hover:bg-gray-100 focus:outline-none"
        >
          View Wealth
        </button>
      </div>
      <div className='text-center text-2xl flex justify-center flex-col items-center gap-6'>
        <div>Welcome! Click below to build your wealth</div>
        <IoMdAddCircle
          fontSize={48}
          className='cursor-pointer text-secondary'
          onClick={handleIconClick}
        />
      </div>
    </>
  );
};

export default Home;
